import { combineReducers } from "redux";
import authReducer from "./auth.reducer";
import chartDataBoardReducer from "./chartDataBoard.reducer"
import boardDataSeriesReducer from "./board_DataSeries.reducer"
import boardReducer from "./board.reducer"
import gapReducer from "./gap.reducer"
import boardScopeReducer from "./boardScope.reducer";
import boardConfigReducer from "./boardConfig.reducer";
import maintainerReducer from "./maintainer.reducer";
import variableReducer from "./variable.reducer";
import boardViewReducer from "./boardView.reducer";
import boardViewComponentsReducer from "./boardViewComponents.reducer";

import ticketReducer from './ticket.reducer';
import answerReducer from './answer.reducer';

import privilegeElementReducer from './privilegeElement.reducer'
import privilegePartyReducer from './privilegeParty.reducer'
import privilegePartyMemberReducer from './privilegePartyMember.reducer'
import contractPartieReducer from './PAY/contractPartie.reducer'
import edpConfigurationReducer from './PAY/edpConfig.reducer'
import edpPreparationReducer from './PAY/edpPrepare.reducer'

import adjustmentReducer from './Adjustment/adjustment.reducer'
import notificationAlertReducer from './Site/alerts.reducer'
import compareContractsReducer from "./compareContracts.reducer";
import notificationTaskReducer from "./NotificationTasks/notificationTasks.reducer";
import bookReducer from "./Book/book.reducer";
import externalHomeReducer from "./externalProfileHome.reducer";
import portfolioReducer from "./portfolio.Reducer";



const rootReducer = combineReducers({
  auth: authReducer,
  chartDataBoard: chartDataBoardReducer,
  reduxBoardDataSeries: boardDataSeriesReducer,
  
  boardScope: boardReducer,
  gapScope: gapReducer,
  boardConsGroupScope: boardScopeReducer,
  configBoardScope: boardConfigReducer,
  boardViewScope: boardViewReducer,
  boardViewComponentsScope: boardViewComponentsReducer,
  compareContractsScope: compareContractsReducer,
  externalHomeScope: externalHomeReducer,
  portfolioScope: portfolioReducer,
  

  maintainerScope: maintainerReducer,
  variableScope: variableReducer,

  tickets: ticketReducer,
  answers: answerReducer,


  privilegeElement: privilegeElementReducer,
  privilegePartys: privilegePartyReducer,
  privilegePartyMembers: privilegePartyMemberReducer,


  contractPartiesState: contractPartieReducer,
  adjustmentState: adjustmentReducer,
  edpConfigurationState: edpConfigurationReducer,
  edpPreparationState: edpPreparationReducer,
  notificationAlertState: notificationAlertReducer,
  notificationTaskState: notificationTaskReducer,

  bookState: bookReducer,
});

export default rootReducer;